import React from "react";
import { useEffect, useState } from "react";
import Loader from "./components/Loader";
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Routers from "./router";
import "./App.css";
import "./App.scss";
import ToastMessage from "./components/ToastMessage";
import ChatButton from "./components/ChatButton";
import NotificationModal from "./components/NotificationModal";
import ErrorBoundary from "./components/ErrorBoundary";
import { closeFlutterBroadcastModal } from "./redux/slices/componentSlice/flutterBroadcastModalSlice";
import { FLUTTER_BROADCAST_MODAL_SLICE_NAME } from "./redux/slices/sliceConstants";

const theme = createTheme({
  typography: {
    fontFamily: "JioType",
  },
  palette: {
    primary: {
      main: "#3535F3",
      light: "#3c44b126",
    },
    secondary: {
      main: "#f83245",
      light: "#f8324526",
    },
    badge: {
      main: "#E32729",
    },
    default: "#f4f5fd",
    background: {
      default: "#f4f5fd",
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        transform: "translateZ(0)",
      },
    },
  },
  props: {
    MuiIconButton: {
      disableRipple: true,
    },
  },
});

function App() {
  const dispatch = useDispatch();
  const flutterBroadcastModal = useSelector(
    (state) => state[FLUTTER_BROADCAST_MODAL_SLICE_NAME]
  );
  const show = useSelector((state) => Boolean(state.componentFlow.show));
  const showIcon = useSelector(
    (state) => state.dashboardFlow.homeDashboardListing?.data?.showJiaChat
  );
  const showChat =
    !window.location.pathname.includes("jia") &&
    !window.location.pathname.includes("/admin") &&
    showIcon;

  return (
    <>
      <ToastMessage />
      {show && <Loader />}
      <ThemeProvider theme={theme}>
        <div className="App">
          {showChat && <ChatButton />}
          <ErrorBoundary label="app-root">
            <Routers />
          </ErrorBoundary>
        </div>
        <NotificationModal
          open={Boolean(flutterBroadcastModal?.open)}
          onClose={() => dispatch(closeFlutterBroadcastModal())}
          notification={flutterBroadcastModal?.notification}
        />
        <CssBaseline />
      </ThemeProvider>
    </>
  );
}

export default App;
